
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("i72d6", function(module, exports) {

$parcel$export(module.exports, "VAR_LEFT_SIDEBAR_WIDTH", () => $dac9c5585e9f3574$export$a30f2e00489a8957);
$parcel$export(module.exports, "VAR_RIGHT_SIDEBAR_WIDTH", () => $dac9c5585e9f3574$export$c103b605cd368aed);
$parcel$export(module.exports, "VAR_TOP_NAVIGATION_HEIGHT", () => $dac9c5585e9f3574$export$3a6a779d9181047c);
$parcel$export(module.exports, "VAR_BANNER_HEIGHT", () => $dac9c5585e9f3574$export$bcd94a6a792e7f96);
$parcel$export(module.exports, "VAR_LEFT_SIDEBAR_FLYOUT", () => $dac9c5585e9f3574$export$b6744d31294864fd);
$parcel$export(module.exports, "LEFT_PANEL", () => $dac9c5585e9f3574$export$344062f7cfc9528e);
$parcel$export(module.exports, "RIGHT_PANEL", () => $dac9c5585e9f3574$export$c7139cc2d6110b5f);
$parcel$export(module.exports, "BANNER", () => $dac9c5585e9f3574$export$238d30785c4bca84);
$parcel$export(module.exports, "TOP_NAVIGATION", () => $dac9c5585e9f3574$export$bec6dca2e63de4ae);
$parcel$export(module.exports, "CONTENT", () => $dac9c5585e9f3574$export$d1213e82613ff4df);
$parcel$export(module.exports, "DEFAULT_BANNER_HEIGHT", () => $dac9c5585e9f3574$export$be83e7118304b28e);
$parcel$export(module.exports, "DEFAULT_TOP_NAVIGATION_HEIGHT", () => $dac9c5585e9f3574$export$4a98ee0bd1ae362);
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $dac9c5585e9f3574$export$539e68c09584883a);
$parcel$export(module.exports, "DEFAULT_RIGHT_SIDEBAR_WIDTH", () => $dac9c5585e9f3574$export$b92df8810d2fcd01);
$parcel$export(module.exports, "COLLAPSED_LEFT_SIDEBAR_WIDTH", () => $dac9c5585e9f3574$export$46acf8758e9e2636);
$parcel$export(module.exports, "MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH", () => $dac9c5585e9f3574$export$70740f5ad8360a78);
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH", () => $dac9c5585e9f3574$export$991d5285ad765a3d);
$parcel$export(module.exports, "MIN_LEFT_SIDEBAR_DRAG_THRESHOLD", () => $dac9c5585e9f3574$export$6949d4f32b161684);
$parcel$export(module.exports, "MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH", () => $dac9c5585e9f3574$export$d6e7e8af042815bb);
$parcel$export(module.exports, "TRANSITION_DURATION", () => $dac9c5585e9f3574$export$3749e1104328fde4);
$parcel$export(module.exports, "FLYOUT_DELAY", () => $dac9c5585e9f3574$export$1074d925b0b82be5);
$parcel$export(module.exports, "PAGE_LAYOUT_LS_KEY", () => $dac9c5585e9f3574$export$451e84a45a9e4a75);
$parcel$export(module.exports, "IS_SIDEBAR_DRAGGING", () => $dac9c5585e9f3574$export$802bb2c050f3db5c);
$parcel$export(module.exports, "IS_SIDEBAR_COLLAPSING", () => $dac9c5585e9f3574$export$5e5e1875c3fd8f4f);
$parcel$export(module.exports, "GRAB_AREA_LINE_SELECTOR", () => $dac9c5585e9f3574$export$70c702a8c5895f03);
$parcel$export(module.exports, "GRAB_AREA_SELECTOR", () => $dac9c5585e9f3574$export$48a43f91e4becf4e);
$parcel$export(module.exports, "RESIZE_BUTTON_SELECTOR", () => $dac9c5585e9f3574$export$dac2fb31a9f6844d);
$parcel$export(module.exports, "RESIZE_CONTROL_SELECTOR", () => $dac9c5585e9f3574$export$9ecd22db14e6c70e);
$parcel$export(module.exports, "PAGE_LAYOUT_SLOT_SELECTOR", () => $dac9c5585e9f3574$export$5253dd9707b8c3ba);
$parcel$export(module.exports, "DEFAULT_I18N_PROPS_SKIP_LINKS", () => $dac9c5585e9f3574$export$206a08f7f8beb554);
$parcel$export(module.exports, "PAGE_LAYOUT_CONTAINER_SELECTOR", () => $dac9c5585e9f3574$export$659ee746b31b360d);
$parcel$export(module.exports, "LEFT_PANEL_WIDTH", () => $dac9c5585e9f3574$export$f963aecf2d4465bd);
$parcel$export(module.exports, "RIGHT_PANEL_WIDTH", () => $dac9c5585e9f3574$export$750459958906793);
$parcel$export(module.exports, "LEFT_SIDEBAR_WIDTH", () => $dac9c5585e9f3574$export$f897e1ed9f8ed251);
$parcel$export(module.exports, "RIGHT_SIDEBAR_WIDTH", () => $dac9c5585e9f3574$export$b44ab66843c05a69);
$parcel$export(module.exports, "TOP_NAVIGATION_HEIGHT", () => $dac9c5585e9f3574$export$aeff86a16f13529);
$parcel$export(module.exports, "BANNER_HEIGHT", () => $dac9c5585e9f3574$export$ed7cc0d417ee89e);
$parcel$export(module.exports, "LEFT_SIDEBAR_FLYOUT_WIDTH", () => $dac9c5585e9f3574$export$d2fa14f05b61e66);
// dimension vars
const $dac9c5585e9f3574$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $dac9c5585e9f3574$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $dac9c5585e9f3574$export$c103b605cd368aed = 'rightSidebarWidth';
const $dac9c5585e9f3574$export$fa34f417972d6341 = 'rightPanelWidth';
const $dac9c5585e9f3574$export$3a6a779d9181047c = 'topNavigationHeight';
const $dac9c5585e9f3574$export$bcd94a6a792e7f96 = 'bannerHeight';
const $dac9c5585e9f3574$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $dac9c5585e9f3574$export$344062f7cfc9528e = 'left-panel';
const $dac9c5585e9f3574$export$c7139cc2d6110b5f = 'right-panel';
const $dac9c5585e9f3574$export$238d30785c4bca84 = 'banner';
const $dac9c5585e9f3574$export$bec6dca2e63de4ae = 'top-navigation';
const $dac9c5585e9f3574$export$d1213e82613ff4df = 'content';
const $dac9c5585e9f3574$export$be83e7118304b28e = 56;
const $dac9c5585e9f3574$export$4a98ee0bd1ae362 = 56;
const $dac9c5585e9f3574$export$539e68c09584883a = 240;
const $dac9c5585e9f3574$export$b92df8810d2fcd01 = 280;
const $dac9c5585e9f3574$export$c3e41153b9288bcf = 368;
const $dac9c5585e9f3574$export$c4d6152f86ea28f6 = 368;
const $dac9c5585e9f3574$export$46acf8758e9e2636 = 20;
const $dac9c5585e9f3574$export$70740f5ad8360a78 = 16;
const $dac9c5585e9f3574$export$991d5285ad765a3d = 240;
const $dac9c5585e9f3574$export$6949d4f32b161684 = 200;
const $dac9c5585e9f3574$export$d6e7e8af042815bb = 350;
const $dac9c5585e9f3574$export$3749e1104328fde4 = 300;
const $dac9c5585e9f3574$export$1074d925b0b82be5 = 200;
const $dac9c5585e9f3574$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $dac9c5585e9f3574$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $dac9c5585e9f3574$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $dac9c5585e9f3574$export$70c702a8c5895f03 = 'data-grab-area-line';
const $dac9c5585e9f3574$export$48a43f91e4becf4e = 'data-grab-area';
const $dac9c5585e9f3574$export$dac2fb31a9f6844d = 'data-resize-button';
const $dac9c5585e9f3574$export$9ecd22db14e6c70e = 'data-resize-control';
const $dac9c5585e9f3574$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $dac9c5585e9f3574$export$206a08f7f8beb554 = 'Skip to:';
const $dac9c5585e9f3574$export$659ee746b31b360d = 'data-layout-container';
const $dac9c5585e9f3574$export$f963aecf2d4465bd = `var(--${$dac9c5585e9f3574$export$cbfb0f5b2869b17b}, 0px)`;
const $dac9c5585e9f3574$export$750459958906793 = `var(--${$dac9c5585e9f3574$export$fa34f417972d6341}, 0px)`;
const $dac9c5585e9f3574$export$f897e1ed9f8ed251 = `var(--${$dac9c5585e9f3574$export$a30f2e00489a8957}, 0px)`;
const $dac9c5585e9f3574$export$b44ab66843c05a69 = `var(--${$dac9c5585e9f3574$export$c103b605cd368aed}, 0px)`;
const $dac9c5585e9f3574$export$aeff86a16f13529 = `var(--${$dac9c5585e9f3574$export$3a6a779d9181047c}, 0px)`;
const $dac9c5585e9f3574$export$ed7cc0d417ee89e = `var(--${$dac9c5585e9f3574$export$bcd94a6a792e7f96}, 0px)`;
const $dac9c5585e9f3574$export$d2fa14f05b61e66 = `var(--${$dac9c5585e9f3574$export$b6744d31294864fd}, ${$dac9c5585e9f3574$export$991d5285ad765a3d}px)`;

});

parcelRegister("nP1jF", function(module, exports) {

$parcel$export(module.exports, "mergeGridStateIntoStorage", () => $13c5dfab80fe88e2$export$f8355a2df0f4a946);
$parcel$export(module.exports, "getGridStateFromStorage", () => $13c5dfab80fe88e2$export$d95e99d8116d17dc);
$parcel$export(module.exports, "removeFromGridStateInStorage", () => $13c5dfab80fe88e2$export$17e3760e0b35f1cd);
$parcel$export(module.exports, "resolveDimension", () => $13c5dfab80fe88e2$export$74732e47915c7839);
$parcel$export(module.exports, "getLeftPanelWidth", () => $13c5dfab80fe88e2$export$b089e01213f07bd);
$parcel$export(module.exports, "getLeftSidebarPercentage", () => $13c5dfab80fe88e2$export$2bca58b6ee823bf7);
$parcel$export(module.exports, "getPageLayoutSlotSelector", () => $13c5dfab80fe88e2$export$e895e3e8b708ae2a);
$parcel$export(module.exports, "getPageLayoutSlotCSSSelector", () => $13c5dfab80fe88e2$export$218ece2c32b7db0e);

var $i72d6 = parcelRequire("i72d6");

var $ebYCw = parcelRequire("ebYCw");
const $13c5dfab80fe88e2$export$f8355a2df0f4a946 = (key, value)=>{
    const storageValue = JSON.parse((0, $ebYCw.default)().getItem((0, $i72d6.PAGE_LAYOUT_LS_KEY)) || '{}');
    if (value !== null && typeof value === 'object') storageValue[key] = {
        ...storageValue[key],
        ...value
    };
    else storageValue[key] = value;
    (0, $ebYCw.default)().setItem((0, $i72d6.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
};
const $13c5dfab80fe88e2$export$d95e99d8116d17dc = (key)=>{
    const storageValue = JSON.parse((0, $ebYCw.default)().getItem((0, $i72d6.PAGE_LAYOUT_LS_KEY)) || '{}');
    return storageValue[key];
};
const $13c5dfab80fe88e2$export$17e3760e0b35f1cd = (key, secondKey)=>{
    const storageValue = JSON.parse((0, $ebYCw.default)().getItem((0, $i72d6.PAGE_LAYOUT_LS_KEY)) || '{}');
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $ebYCw.default)().setItem((0, $i72d6.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
};
const $13c5dfab80fe88e2$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
    if (shouldPersist) {
        const cachedGridState = $13c5dfab80fe88e2$export$d95e99d8116d17dc('gridState');
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};
const $13c5dfab80fe88e2$export$b089e01213f07bd = ()=>{
    if (typeof window === 'undefined') return 0;
    return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue(`--${(0, $i72d6.LEFT_PANEL_WIDTH)}`), 10) || 0;
};
const $13c5dfab80fe88e2$export$2bca58b6ee823bf7 = (currentWidth, maxWidth)=>{
    const total = (currentWidth - (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH)) / (maxWidth - (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH));
    if (total < 0) return 0;
    if (total > 1) return 100;
    return Math.floor(total * 100);
};
const $13c5dfab80fe88e2$export$e895e3e8b708ae2a = (slotName)=>({
        [(0, $i72d6.PAGE_LAYOUT_SLOT_SELECTOR)]: slotName
    });
const $13c5dfab80fe88e2$export$218ece2c32b7db0e = (slotName)=>`[${0, $i72d6.PAGE_LAYOUT_SLOT_SELECTOR}='${slotName}']`;

});
parcelRegister("ebYCw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b70396b292c2d1e9$export$2e2bcd8739ae039);
// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
const $b70396b292c2d1e9$var$isLocalStorageSupported = ()=>{
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        const testKey = `__test_${Date.now()}__`;
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
};
const $b70396b292c2d1e9$var$safeLocalStorage = ()=>{
    if ($b70396b292c2d1e9$var$isLocalStorageSupported()) return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === 'undefined') return {
        getItem: (_key)=>null,
        setItem: (_key, _value)=>null,
        removeItem: (_key)=>null,
        clear: ()=>null,
        key: (_index)=>null,
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    const storageAPI = {
        getItem: (key)=>{
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: (key, value)=>{
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: (key)=>{
            delete window.__localStorageFallback[key];
        },
        clear: ()=>{
            for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $b70396b292c2d1e9$export$2e2bcd8739ae039 = $b70396b292c2d1e9$var$safeLocalStorage;

});


parcelRegister("fS0n4", function(module, exports) {

$parcel$export(module.exports, "default", () => $82ece7e83416c6fa$export$2e2bcd8739ae039);

var $nP1jF = parcelRequire("nP1jF");
const $82ece7e83416c6fa$var$publishGridState = (gridState)=>{
    Object.entries(gridState).forEach(([slotName, value])=>{
        if (!value) {
            document.documentElement.style.removeProperty(`--${slotName}`);
            (0, $nP1jF.removeFromGridStateInStorage)('gridState', slotName);
            return;
        }
        //Update the css variable
        document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
        // also update state in local storage so that
        // it persists across page refresh, across tabs etc
        (0, $nP1jF.mergeGridStateIntoStorage)('gridState', {
            [slotName]: value
        });
    });
};
var $82ece7e83416c6fa$export$2e2bcd8739ae039 = $82ece7e83416c6fa$var$publishGridState;

});

parcelRegister("1HIA2", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $2361d223ca5d546c$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinks", () => $2361d223ca5d546c$export$c9d9cb2ee9590f87);
$parcel$export(module.exports, "useSkipLink", () => $2361d223ca5d546c$export$89d9323301efc7d6);

var $gwFzn = parcelRequire("gwFzn");

var $ee7An = parcelRequire("ee7An");
const $2361d223ca5d546c$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $gwFzn.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $ee7An.default),
    unregisterSkipLink: (0, $ee7An.default)
});
const $2361d223ca5d546c$export$c9d9cb2ee9590f87 = ()=>(0, $gwFzn.useContext)($2361d223ca5d546c$export$4c5cc3b14c7678a);
const $2361d223ca5d546c$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $2361d223ca5d546c$export$c9d9cb2ee9590f87();
    (0, $gwFzn.useEffect)(()=>{
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("3xCvY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6c128fbf4bc9150$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $6fnsQ = parcelRequire("6fnsQ");
const $b6c128fbf4bc9150$var$focusStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $6fnsQ.B100)})`}`,
            outline: 'none'
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ const $b6c128fbf4bc9150$var$sidebarFocusStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div > div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $6fnsQ.B100)})`}`,
            outline: 'none'
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ const $b6c128fbf4bc9150$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3jLHL.ClassNames), null, ({ css: css })=>children({
            className: isSidebar ? css($b6c128fbf4bc9150$var$sidebarFocusStyles) : css($b6c128fbf4bc9150$var$focusStyles)
        }));
};
var $b6c128fbf4bc9150$export$2e2bcd8739ae039 = $b6c128fbf4bc9150$var$SlotFocusRing;

});

parcelRegister("gXiBW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dc5d52c31c302c7$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $bWLcG = parcelRequire("bWLcG");
/**
 * Hoists slot dimension styles to the root element.
 */ const $5dc5d52c31c302c7$var$SlotDimensions = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root{--${variableName}:${value}px;}`;
    if (mobileValue) style += ` ${(0, $bWLcG.UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $7UHDa.jsx)("style", {
        children: style
    }));
};
var $5dc5d52c31c302c7$export$2e2bcd8739ae039 = $5dc5d52c31c302c7$var$SlotDimensions;

});

parcelRegister("je0s0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfb68832b10ab658$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $i72d6 = parcelRequire("i72d6");

var $nP1jF = parcelRequire("nP1jF");

var $fS0n4 = parcelRequire("fS0n4");
var $1HIA2 = parcelRequire("1HIA2");

var $3xCvY = parcelRequire("3xCvY");

var $gXiBW = parcelRequire("gXiBW");
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $bfb68832b10ab658$var$fixedInnerStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $i72d6.RIGHT_SIDEBAR_WIDTH),
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $i72d6.BANNER_HEIGHT)} + ${(0, $i72d6.TOP_NAVIGATION_HEIGHT)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: `calc(${(0, $i72d6.RIGHT_PANEL_WIDTH)})`
});
const $bfb68832b10ab658$var$staticInnerStyles = (0, $3jLHL.css)({
    height: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $bfb68832b10ab658$var$outerStyles = (0, $3jLHL.css)({
    width: (0, $i72d6.RIGHT_SIDEBAR_WIDTH)
});
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $bfb68832b10ab658$var$fixedOuterStyles = (0, $3jLHL.css)({
    '&::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $i72d6.RIGHT_SIDEBAR_WIDTH),
        content: "''"
    }
});
/**
 * __Right sidebar__
 *
 * Provides a slot for a right sidebar within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $bfb68832b10ab658$var$RightSidebar = (props)=>{
    const { children: children, width: width = (0, $i72d6.DEFAULT_RIGHT_SIDEBAR_WIDTH), isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightSidebarWidth = (0, $nP1jF.resolveDimension)((0, $i72d6.VAR_RIGHT_SIDEBAR_WIDTH), width, shouldPersistWidth);
    (0, $gwFzn.useEffect)(()=>{
        (0, $fS0n4.default)({
            [(0, $i72d6.VAR_RIGHT_SIDEBAR_WIDTH)]: rightSidebarWidth
        });
        return ()=>{
            (0, $fS0n4.default)({
                [(0, $i72d6.VAR_RIGHT_SIDEBAR_WIDTH)]: 0
            });
        };
    }, [
        rightSidebarWidth,
        id
    ]);
    (0, $1HIA2.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3xCvY.default), {
        isSidebar: true
    }, ({ className: className })=>/*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            "data-testid": testId,
            css: [
                $bfb68832b10ab658$var$outerStyles,
                isFixed && $bfb68832b10ab658$var$fixedOuterStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $nP1jF.getPageLayoutSlotSelector)('right-sidebar')
        }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gXiBW.default), {
            variableName: (0, $i72d6.VAR_RIGHT_SIDEBAR_WIDTH),
            value: rightSidebarWidth
        }), /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            css: [
                isFixed && $bfb68832b10ab658$var$fixedInnerStyles,
                !isFixed && $bfb68832b10ab658$var$staticInnerStyles
            ]
        }, children)));
};
var $bfb68832b10ab658$export$2e2bcd8739ae039 = $bfb68832b10ab658$var$RightSidebar;

});

parcelRegister("l4CMG", function(module, exports) {

$parcel$export(module.exports, "useSpaceGettingStartedTour", () => $8ffb42dddb8b1ad4$export$9b6268da5f7e530a);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $8ffb42dddb8b1ad4$var$initialState = {
    isSpaceGettingStartedTourInProgress: false
};
const $8ffb42dddb8b1ad4$var$actions = {
    setIsSpaceGettingStartedTourInProgress: (value)=>({ setState: setState })=>{
            setState({
                isSpaceGettingStartedTourInProgress: value
            });
        }
};
const $8ffb42dddb8b1ad4$var$Store = (0, $4ZoIm.createStore)({
    initialState: $8ffb42dddb8b1ad4$var$initialState,
    actions: $8ffb42dddb8b1ad4$var$actions
});
const $8ffb42dddb8b1ad4$export$9b6268da5f7e530a = (0, $iFWZA.createHook)($8ffb42dddb8b1ad4$var$Store);
const $8ffb42dddb8b1ad4$export$d2c730059c91ca43 = (0, $iFWZA.createActionsHook)($8ffb42dddb8b1ad4$var$Store);

});

parcelRegister("5XPyz", function(module, exports) {

$parcel$export(module.exports, "BannerContainer", () => $e36ff8521eaa3fdf$export$f316edcbf748c37b);

var $jmjWc = parcelRequire("jmjWc");

const $e36ff8521eaa3fdf$export$f316edcbf748c37b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bTjE2",
    name: "BannerContainer",
    loader: async ()=>(await (parcelRequire("hmMVe"))).BannerContainer
});

});
parcelRegister("hmMVe", function(module, exports) {

let $ca4a70a442bf5527$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ca4a70a442bf5527$var$load("i73Fi"),
    $ca4a70a442bf5527$var$load("4Bp5z"),
    $ca4a70a442bf5527$var$load("joJy8"),
    $ca4a70a442bf5527$var$load("aHE9G"),
    $ca4a70a442bf5527$var$load("aZinD"),
    $ca4a70a442bf5527$var$load("avZlC")
]).then(()=>parcelRequire('9ZNsj'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});




parcelRegister("1C7kY", function(module, exports) {

$parcel$export(module.exports, "GlobalComponentsLoader", () => $c9ec1f4c06aad517$export$23822a00be419508);

var $jmjWc = parcelRequire("jmjWc");

const $c9ec1f4c06aad517$export$23822a00be419508 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KYiA6",
    name: "GlobalComponentsLoader",
    loader: async ()=>(await (parcelRequire("9LBIs"))).GlobalComponents
});

});
parcelRegister("9LBIs", function(module, exports) {

let $71c5c2778ce12da2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $71c5c2778ce12da2$var$load("egKEo"),
    $71c5c2778ce12da2$var$load("2iqdN"),
    $71c5c2778ce12da2$var$load("2F69B"),
    $71c5c2778ce12da2$var$load("dA1E5"),
    $71c5c2778ce12da2$var$load("c6MKV"),
    $71c5c2778ce12da2$var$load("aZinD"),
    $71c5c2778ce12da2$var$load("cyGuT"),
    $71c5c2778ce12da2$var$load("2Qrvo"),
    $71c5c2778ce12da2$var$load("8fTZe"),
    $71c5c2778ce12da2$var$load("ffEVr"),
    $71c5c2778ce12da2$var$load("joJy8"),
    $71c5c2778ce12da2$var$load("aHE9G"),
    $71c5c2778ce12da2$var$load("jryQt")
]).then(()=>parcelRequire('73TCo'));

});


parcelRegister("iCTcO", function(module, exports) {

$parcel$export(module.exports, "PreviewPanelContainer", () => $2c25ef82052c394f$export$f143b4bd86d1e004);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $je0s0 = parcelRequire("je0s0");

var $2QMNQ = parcelRequire("2QMNQ");
var $8gtQ7 = parcelRequire("8gtQ7");

var $eK5zz = parcelRequire("eK5zz");

var $bssir = parcelRequire("bssir");

var $9wGTI = parcelRequire("9wGTI");

var $gz8ZY = parcelRequire("gz8ZY");

var $5DOPg = parcelRequire("5DOPg");
const $2c25ef82052c394f$var$PreviewPanelSplitter = ()=>{
    const intl = (0, $dBxQj.default)();
    const { setPanelWidth: setPanelWidth } = (0, $8gtQ7.usePreviewPanelsActions)();
    const onResizeEnd = (0, $gwFzn.useCallback)(({ finalWidth: finalWidth })=>{
        setPanelWidth(finalWidth);
    }, [
        setPanelWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bssir.PanelSplitter), {
        label: intl.formatMessage((0, $5DOPg.messages).panelSplitter),
        onResizeEnd: onResizeEnd
    });
};
const $2c25ef82052c394f$var$NavWrapper = ({ children: children, width: width })=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    if (isNav4Enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eK5zz.Panel), {
        defaultWidth: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($2c25ef82052c394f$var$PreviewPanelSplitter, null), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $je0s0.default), {
        width: width
    }, children);
};
function $2c25ef82052c394f$export$f143b4bd86d1e004() {
    const panel = (0, $2QMNQ.useCurrentPreviewPanel)();
    if (!(0, $9wGTI.fg)('confluence_preview_panels')) return null;
    if (panel == null) return null;
    const { content: PanelContent, width: width } = panel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($2c25ef82052c394f$var$NavWrapper, {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(PanelContent, null));
}

});
parcelRegister("5DOPg", function(module, exports) {

$parcel$export(module.exports, "messages", () => $36b11f7822ba6f88$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $36b11f7822ba6f88$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    panelSplitter: {
        id: "preview-panel-api.resize.label",
        defaultMessage: "Resize panel"
    }
});

});


parcelRegister("cJWhP", function(module, exports) {

$parcel$export(module.exports, "NavigationExperienceWrapper", () => $bd996ec529999f47$export$ac3e7903e24ee02d);

var $gwFzn = parcelRequire("gwFzn");

var $irVI7 = parcelRequire("irVI7");
var $aJPUt = parcelRequire("aJPUt");
var $1kHsc = parcelRequire("1kHsc");

var $4l6Wo = parcelRequire("4l6Wo");
/**
 * Treat blog nav and space nav as the same experience.
 */ const $bd996ec529999f47$var$transformView = (view)=>{
    if (view === (0, $4l6Wo.CONTAINER_BLOG_ID)) return 0, $4l6Wo.CONTAINER_HOME_ID;
    return view;
};
const $bd996ec529999f47$export$ac3e7903e24ee02d = ({ view: view, children: children, navVersion: navVersion })=>{
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const abortExp = (0, $gwFzn.useCallback)((name)=>experienceTracker.abort({
            name: name,
            reason: 'navigation container view changed',
            attributes: {
                navVersion: navVersion
            }
        }), [
        experienceTracker,
        navVersion
    ]);
    const startExp = (0, $gwFzn.useCallback)((name)=>experienceTracker.start({
            name: name,
            timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
            attributes: {
                navVersion: navVersion
            }
        }), [
        experienceTracker,
        navVersion
    ]);
    const transformedView = $bd996ec529999f47$var$transformView(view);
    (0, $gwFzn.useLayoutEffect)(()=>{
        const containerName = (0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE);
        const adminName = (0, $irVI7.APP_NAV_ADMIN_EXPERIENCE);
        switch(transformedView){
            case 0, $4l6Wo.CONTAINER_HOME_ID:
                startExp(containerName);
                abortExp(adminName);
                break;
            case 0, $4l6Wo.PRODUCT_HOME_ID:
            case 0, $4l6Wo.PRODUCT_ADDONS_ID:
                abortExp(containerName);
                abortExp(adminName);
                break;
            case 0, $4l6Wo.ADMIN_HOME_ID:
                startExp(adminName);
                abortExp(containerName);
        }
    }, [
        transformedView,
        startExp,
        abortExp
    ]);
    (0, $gwFzn.useLayoutEffect)(()=>{
        startExp((0, $irVI7.APP_NAV_GLOBAL_EXPERIENCE));
    }, [
        startExp
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
};

});

parcelRegister("eJTjU", function(module, exports) {

$parcel$export(module.exports, "useScrollTree", () => $ad0ecba6dc7e91fa$export$ccd8c615ba434dec);

var $gwFzn = parcelRequire("gwFzn");

var $2esS1 = parcelRequire("2esS1");
const $ad0ecba6dc7e91fa$export$ccd8c615ba434dec = ({ view: view })=>{
    const pageTreeUpdater = (0, $gwFzn.useRef)();
    const scrollTree = (0, $gwFzn.useCallback)(()=>{
        if (view === (0, $2esS1.CONTAINER_HOME_ID) && pageTreeUpdater.current) pageTreeUpdater.current.scrollToCurrentPage();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        view,
        pageTreeUpdater.current
    ]);
    return {
        pageTreeUpdater: pageTreeUpdater,
        scrollTree: scrollTree
    };
};

});
parcelRegister("2esS1", function(module, exports) {

$parcel$export(module.exports, "CONTAINER_HOME_LOADING_ID", () => $ba0a4d7f1b78ed67$export$4b542de2568592b5);
$parcel$export(module.exports, "CONTAINER_HOME_ID", () => $ba0a4d7f1b78ed67$export$b8c5fd47fee73aae);
$parcel$export(module.exports, "CONTAINER_BLOG_ID", () => $ba0a4d7f1b78ed67$export$1237a23d18648140);
$parcel$export(module.exports, "CONTAINER_ADMIN_HOME_ID", () => $ba0a4d7f1b78ed67$export$c3f826fbea17177);
$parcel$export(module.exports, "COMPANY_HUB_SETTINGS_ID", () => $ba0a4d7f1b78ed67$export$e1cac4d5c92cf74b);
$parcel$export(module.exports, "ADMIN_HOME_ID", () => $ba0a4d7f1b78ed67$export$a9aa544aabcc3ca1);
$parcel$export(module.exports, "PRODUCT_HOME_ID", () => $ba0a4d7f1b78ed67$export$823dfce5c2bceecb);
// Paths
const $ba0a4d7f1b78ed67$export$4b542de2568592b5 = 'container/home/loading';
const $ba0a4d7f1b78ed67$export$b8c5fd47fee73aae = 'container/home';
const $ba0a4d7f1b78ed67$export$1237a23d18648140 = 'container/blog';
const $ba0a4d7f1b78ed67$export$c3f826fbea17177 = 'container/admin/home';
const $ba0a4d7f1b78ed67$export$e1cac4d5c92cf74b = 'container/admin/company-hub';
const $ba0a4d7f1b78ed67$export$a9aa544aabcc3ca1 = 'admin/home';
const $ba0a4d7f1b78ed67$export$823dfce5c2bceecb = 'product/home';

});


parcelRegister("kmLIp", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $5fff77e1c664da88$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $5fff77e1c664da88$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    TopNav: {
        id: "page-layout.top.nav",
        defaultMessage: "Confluence navigation"
    },
    Banner: {
        id: "page-layout.banner",
        defaultMessage: "Banner"
    },
    SideNav: {
        id: "page-layout.side.nav",
        defaultMessage: "Side navigation"
    },
    Main: {
        id: "page-layout.main",
        defaultMessage: "Page"
    },
    SkipLinks: {
        id: "page-layout.skip.links",
        defaultMessage: "Jump to"
    }
});

});

parcelRegister("lPNJr", function(module, exports) {

$parcel$export(module.exports, "SSR_LAYOUT_DATA_ATTR", () => $234a7212b3053f5f$export$f6b09748eb1e2d30);
$parcel$export(module.exports, "SSR_IFRAME_ATTR", () => $234a7212b3053f5f$export$2306961d40008e49);
$parcel$export(module.exports, "LayoutMainWrapper", () => $234a7212b3053f5f$export$712225703044cda);
$parcel$export(module.exports, "ZIndexWrapper", () => $234a7212b3053f5f$export$6bdda512681a5774);
$parcel$export(module.exports, "StyleFixSSRContentForNewLayoutWithRightSidebar", () => $234a7212b3053f5f$export$b8351f78ef0f3a5b);
$parcel$export(module.exports, "fixSSRContentForNewLayoutWithRightSidebarStyles", () => $234a7212b3053f5f$export$d1bb8697b964b9c);
$parcel$export(module.exports, "styleCodeBlockFix", () => $234a7212b3053f5f$export$7e7c976a35e3cca4);
$parcel$export(module.exports, "styleNoPrintNav", () => $234a7212b3053f5f$export$8aa27b5c972d9940);
$parcel$export(module.exports, "fontFamilyCLSFix", () => $234a7212b3053f5f$export$d1a48f8b51d4f7e);
$parcel$export(module.exports, "accountMenuHeadingFix", () => $234a7212b3053f5f$export$1658edd19dc77e8);
$parcel$export(module.exports, "moreActionDropdownCLSFix", () => $234a7212b3053f5f$export$8ffff4752f6c99c5);
$parcel$export(module.exports, "globalStylesCompiled", () => $234a7212b3053f5f$export$191b652ca0b16b3f);
$parcel$export(module.exports, "ContentRightSidePanel", () => $234a7212b3053f5f$export$fd1a59daeb9a7e85);
/* presentationComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ // We have deprecated emotion. Please use compiled instead
// eslint-disable-next-line no-restricted-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $lhCUr = parcelRequire("lhCUr");

var $i72d6 = parcelRequire("i72d6");

var $K0HEo = parcelRequire("K0HEo");
const $234a7212b3053f5f$export$f6b09748eb1e2d30 = 'data-main-content';
const $234a7212b3053f5f$export$2306961d40008e49 = 'data-flex-container'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
const $234a7212b3053f5f$export$712225703044cda = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showBreadcrumbNavHeader: showBreadcrumbNavHeader, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1bgi _c3a01fl4 _1u5916n6 _2iuc1fl4 _ylxn1v5u _moiv16n6",
            __cmplp.showBreadcrumbNavHeader ? "_17gl1wqb" : "_17glidpf",
            __cmplp.className
        ])
    });
});
const $234a7212b3053f5f$export$6bdda512681a5774 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { zIndex: zIndex, showQuickStart: showQuickStart, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w6mvmh": (0, $iAWao.default)(__cmplp.zIndex)
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1pby1fcb _e1qhidpf",
            __cmplp.showQuickStart ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
}); // This uses CCS variables from atlaskit/page-layout to make sure
const $234a7212b3053f5f$export$b8351f78ef0f3a5b = (totalHeight)=>{
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $lhCUr.css)("#ui-global-sidebar-section{z-index:auto !important;width:100%;}[", $234a7212b3053f5f$export$f6b09748eb1e2d30, "],[", $234a7212b3053f5f$export$2306961d40008e49, "]{width:calc( 100% - ", (0, $i72d6.LEFT_PANEL_WIDTH), " - ", (0, $i72d6.LEFT_SIDEBAR_WIDTH), " - ", (0, $i72d6.RIGHT_PANEL_WIDTH), " - ", (0, $i72d6.RIGHT_SIDEBAR_WIDTH), " ) !important;top:", totalHeight + 2, "px !important;position:absolute;left:calc(", (0, $i72d6.LEFT_PANEL_WIDTH), " + ", (0, $i72d6.LEFT_SIDEBAR_WIDTH), ");z-index:auto;box-sizing:border-box;&#admin-content{.upm-manage{#upm-manage-type,.upm-details .upm-plugin-info .upm-column{z-index:1;}}}}[", $234a7212b3053f5f$export$2306961d40008e49, "] > [", $234a7212b3053f5f$export$f6b09748eb1e2d30, "]{display:none;}[", $234a7212b3053f5f$export$2306961d40008e49, "] > main#main.aui-page-panel{overflow:hidden;overflow-y:auto;height:calc(100vh - ", (0, $K0HEo.UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY), " - 2px);min-height:calc( 100vh - ", (0, $K0HEo.UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY), " - 2px );}");
};
const $234a7212b3053f5f$export$d1bb8697b964b9c = `
#ui-global-sidebar-section {
	z-index: auto !important;
	width: 100%;
}

[${$234a7212b3053f5f$export$f6b09748eb1e2d30}], [${$234a7212b3053f5f$export$2306961d40008e49}] {
	width: calc(
		100% - ${(0, $i72d6.LEFT_PANEL_WIDTH)} - ${(0, $i72d6.LEFT_SIDEBAR_WIDTH)} - ${(0, $i72d6.RIGHT_PANEL_WIDTH)} -
			${(0, $i72d6.RIGHT_SIDEBAR_WIDTH)}
	) !important;
	position: absolute;
	left: calc(${(0, $i72d6.LEFT_PANEL_WIDTH)} + ${(0, $i72d6.LEFT_SIDEBAR_WIDTH)});
	z-index: auto;
	box-sizing: border-box;

	&#admin-content {
		/* admin nav -> manage apps */
		.upm-manage {
			#upm-manage-type, /* app type dropdown filter */
		.upm-details .upm-plugin-info .upm-column {
				/* expand accordion to show app detail -> 3 column info table */
				z-index: 1;
			}
		}
	}
}
[${$234a7212b3053f5f$export$2306961d40008e49}] > [${$234a7212b3053f5f$export$f6b09748eb1e2d30}] {
	display: none;
}

/* add overflow scrolling to ssred pages with heights longer than side navigation */
[${$234a7212b3053f5f$export$2306961d40008e49}] > main#main.aui-page-panel {
	overflow: hidden;
	overflow-y: auto;
	height: calc(100vh - ${(0, $K0HEo.UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY)} - 2px);
	min-height: calc(
		100vh - ${(0, $K0HEo.UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY)} - 2px
	); /* for responsiveness in small height windows */
}
`;
const $234a7212b3053f5f$export$7e7c976a35e3cca4 = {
    name: "e2q3i8",
    styles: ".code-block.right-shadow{z-index:2;}"
}; //CSS hack for noPrint
const $234a7212b3053f5f$export$8aa27b5c972d9940 = {
    name: "pusxiv",
    styles: "[data-ds--page-layout--slot='top-navigation'],[data-ds--page-layout--slot='left-sidebar']{@media print{display:none !important;}}"
}; //To make sure we are using the same font family set by atlassian-frontend theme.
const $234a7212b3053f5f$export$d1a48f8b51d4f7e = {
    name: "xft3tq",
    styles: ".PageContent{font-family:var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);}"
}; // CSS hack to override batch CSS h3 styling for account menu
const $234a7212b3053f5f$export$1658edd19dc77e8 = {
    name: "jr61yo",
    styles: "[data-testid='confluence-account-menu--content--details--name']{font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);}"
}; //to remove cls from more action dropdown
const $234a7212b3053f5f$export$8ffff4752f6c99c5 = {
    name: "19sbpkz",
    styles: "[data-testid='content-tools-dropdown-menu--content']{width:220px;}"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css
const $234a7212b3053f5f$export$191b652ca0b16b3f = `
	/* CSS hack for code block */
	.code-block.right-shadow {
		z-index: 2;
	}
	/* CSS hack for noPrint */
	[data-ds--page-layout--slot='top-navigation'],
	[data-ds--page-layout--slot='left-sidebar'] {
		@media print {
			display: none !important;
		}
	}
	/* To make sure we are using the same font family set by atlassian-frontend theme. */
	.PageContent {
		font-family: ${"var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};
	}
	/* To remove cls from more action dropdown */
	[data-testid='content-tools-dropdown-menu--content'] {
		width: 220px;
	}

	/* CSS hack to override batch CSS h3 styling for account menu */
	[data-testid='confluence-account-menu--content--details--name'] {
		font: ${"var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};
	}
`;
const $234a7212b3053f5f$export$fd1a59daeb9a7e85 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_4t3i1osq _1bsb1osq _10pb1osq _9m3z1osq _16tepfqs",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hayzU", function(module, exports) {

$parcel$export(module.exports, "LazyImpersonationFlag", () => $3183c72dd59199f3$export$4fca365a8ad2f625);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $dIouf = parcelRequire("dIouf");

const $3183c72dd59199f3$var$ImpersonationFlagV2Loader = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "61Lty",
    name: "ImpersonationFlagV2Loader",
    loader: async ()=>(await (parcelRequire("5VGiC"))).ImpersonationFlag
});
const $3183c72dd59199f3$var$LazyImpersonationFlagComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3183c72dd59199f3$var$ImpersonationFlagV2Loader, null);
const $3183c72dd59199f3$export$4fca365a8ad2f625 = (0, $dIouf.withTransparentErrorBoundary)({
    attribution: (0, $dIouf.Attribution).PERMISSIONS_EXPERIENCE
})($3183c72dd59199f3$var$LazyImpersonationFlagComponent);

});
parcelRegister("5VGiC", function(module, exports) {

let $451316664a4bb94e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $451316664a4bb94e$var$load("kNFat").then(()=>parcelRequire('iETFY'));

});


parcelRegister("1qDZ3", function(module, exports) {

$parcel$export(module.exports, "PageLayoutContextProviderWrapper", () => $e33908ef21162ab8$export$968a8c4aa27e5f45);

var $gwFzn = parcelRequire("gwFzn");

var $6yagU = parcelRequire("6yagU");

var $57DNK = parcelRequire("57DNK");

var $jln20 = parcelRequire("jln20");

var $bBQPT = parcelRequire("bBQPT");

var $9wGTI = parcelRequire("9wGTI");
const $e33908ef21162ab8$export$968a8c4aa27e5f45 = ({ children: children })=>{
    if (!(0, $9wGTI.fg)('confluence_preview_panels')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jln20.RightSidebarContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $57DNK.NotesContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bBQPT.InProductHelpProvider), null, children)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6yagU.ConfluencePreviewPanelsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jln20.RightSidebarContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $57DNK.NotesContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bBQPT.InProductHelpProvider), null, children))));
};

});
parcelRegister("6yagU", function(module, exports) {

$parcel$export(module.exports, "ConfluencePreviewPanelsProvider", () => $8e2f4c2c3b316f28$export$2b37b625358608ab);

var $gwFzn = parcelRequire("gwFzn");

var $2QMNQ = parcelRequire("2QMNQ");

var $ceqyO = parcelRequire("ceqyO");
const $8e2f4c2c3b316f28$export$2b37b625358608ab = ({ children: children })=>{
    const { closeAllOpenSidePanels: closeAllOpenSidePanels } = (0, $ceqyO.useCloseAllOpenSidePanels)();
    const onPreviewPanelOpen = (0, $gwFzn.useCallback)(()=>{
    // Add any additional logic here for opening preview panels.
    }, []);
    const onPreviewPanelClose = (0, $gwFzn.useCallback)(()=>{
        // Add any additional logic here for closing preview panels.
        closeAllOpenSidePanels();
    }, [
        closeAllOpenSidePanels
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2QMNQ.PreviewPanelsProvider), {
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    }, children);
};

});
parcelRegister("ceqyO", function(module, exports) {

$parcel$export(module.exports, "useCloseAllOpenSidePanels", () => $c2c7863877648c93$export$5b6068b393c77c1e);

var $9wGTI = parcelRequire("9wGTI");

var $aWwYt = parcelRequire("aWwYt");
const $c2c7863877648c93$export$5b6068b393c77c1e = ()=>{
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const closeAllOpenSidePanels = ()=>{
        window.dispatchEvent(new Event('closeGlobalSidebar'));
        if ((0, $9wGTI.fg)('confluence_frontend_object_sidebar')) hideObjectSidebar();
    };
    return {
        closeAllOpenSidePanels: closeAllOpenSidePanels
    };
};

});




//# sourceMappingURL=PageLayout.ac9c1f6a.js.map
